import {TagRepository} from '../../classes/repository/TagRepository';
import {ContentRepository} from '../../classes/repository/ContentRepository';
import {ExportRepository} from '../../classes/repository/ExportRepository';
import 'core-js/es6/array';
import {BoxRepository} from "../../classes/repository/BoxRepository";
import {LinkRepository} from "../../classes/repository/LinkRepository";
import {ConfigRepository} from "../../classes/repository/ConfigRepository";

const state = {
    tags: [],
    dashboard: [],
    links: [],
    contents: [],
    selectedTags: [],
    selectedTypes: [],
    editBox: {},
    editLink: {},
    editContent: {},
    results: [],
    searchWords: '',
    messages: [],
    configs: {},
    editConfig: {},
    boxes: [],
    configArray: [
        {
            code: 'row1.col1',
            title: 'Reihe 1 Spalte 1',
            description: ''
        },
        {
            code: 'row1.col2',
            title: 'Reihe 1 Spalte 2',
            description: ''
        },
        {
            code: 'row1.col3',
            title: 'Reihe 1 Spalte 3',
            description: ''
        },
        {
            code: 'row1.col3',
            title: 'Reihe 1 Spalte 3',
            description: ''
        },
    ],
    configTypes: [
        {
            id: 'box',
            title: 'box'
        },
        {
            id: 'content',
            title: 'content'
        }
    ],
    contentTypes: [
        {
            id: 1,
            title: 'code'
        },
        {
            id: 2,
            title: 'geburtstag'
        },
        {
            id: 3,
            title: 'tabelle'
        },
        {
            id: 4,
            title: 'text'
        },
    ],
};

const getters = {
    allTags: state => state.tags.sort(function (a,b) {
        if(a.title < b.title) return -1;
        return 1;
    }),
    selectedTags: state => state.selectedTags,
    selectedTypes: state => state.selectedTypes,
    searchWords: state => state.searchWords,
    allResults: state => state.results,
    allConfigs: state => state.configs,
    allContents: state =>  state.contents.sort(function (a,b) {
        if(a.title < b.title) return -1;
        return 1;
    }),
    dashboardCols: state => state.dashboard,
    allMessages: state => state.messages,
    allBoxes: state => state.boxes,
    editBox: state => state.editBox,
    editConfig: state => state.editConfig,
    editContent: state => state.editContent,
    editLink: state => state.editLink,
    allLinks: state => state.links,
    allContentTypes: state =>  state.contentTypes.sort(function (a,b) {
            if(a.title < b.title) return -1;
            return 1;
    }),
    allConfigTypes: state =>  state.configTypes.sort(function (a,b) {
        if(a.title < b.title) return -1;
        return 1;
    })
};

const actions = {

    async getConfigs({commit}) {
        let configRepository = new ConfigRepository();
        //configRepository.changeSchema();
        let configPromise = configRepository.findAll();
        await configPromise.then(function(configs) {
            actions.addConfig('row1.col1','Reihe 1 Spalte 1', '', configs);
            actions.addConfig('row1.col2','Reihe 1 Spalte 2','', configs);
            actions.addConfig('row1.col3','Reihe 1 Spalte 3','', configs);
            actions.addConfig('row1.col4','Reihe 1 Spalte 4','', configs);
            actions.addConfig('row2.col1','Reihe 2 Spalte 1', '', configs);
            actions.addConfig('row2.col2','Reihe 2 Spalte 2','', configs);
            actions.addConfig('row2.col3','Reihe 2 Spalte 3','', configs);
            actions.addConfig('row2.col4','Reihe 2 Spalte 4','', configs);
        });

        let newConfigRepository = new ConfigRepository();
        let configPromiseNew = newConfigRepository.findAll();
        await configPromiseNew.then(function(configs) {
            commit('setConfigs', configs);
        });
    },

    async getContents({commit}) {

        let contentRepository = new ContentRepository();
        let contentPromise = contentRepository.findAll();
        await contentPromise.then(function(contents) {
            commit('setContents', contents);

        });
    },

    async getDashboard({commit}) {
        state.dashboard = [];

        await actions.getConfigs({commit});

        await actions.pushDashboardItem({commit}, 'row1.col1');
        await actions.pushDashboardItem({commit}, 'row1.col2');
        await actions.pushDashboardItem({commit}, 'row1.col3');
        await actions.pushDashboardItem({commit}, 'row1.col4');
        await actions.pushDashboardItem({commit}, 'row2.col1');
        await actions.pushDashboardItem({commit}, 'row2.col2');
        await actions.pushDashboardItem({commit}, 'row2.col3');
        await actions.pushDashboardItem({commit}, 'row2.col4');
    },

    async pushDashboardItem({commit}, code) {
        let config = state.configs.filter(function(config){return config.code === code})[0];
        if(config.type === 'content') {
            let contentRepository = new ContentRepository();
            let contentPromise = contentRepository.findById(parseInt(config.foreign));
            await contentPromise.then(function(content) {
                config.object = content[0];
                config.htmlId = 'test' + config.id;
                commit('pushDashboardItem', config);
            });
        }
        else if(config.type === 'box') {
            let boxRepository = new BoxRepository();
            let boxPromise = boxRepository.findById(parseInt(config.foreign));
            await boxPromise.then(function(boxes) {
                let box = boxes[0];

                let linkRepository = new LinkRepository();
                let boxWithLinksPromise = linkRepository.findByBox(box.id);
                boxWithLinksPromise.then(function(links){
                    box.links = links;
                    config.object = box;
                    config.htmlId = 'test' + config.id;
                    commit('pushDashboardItem', config);
                });
            });
        }
    },

    addConfig(code, title, description, configs) {
        let isNew = true;

        configs.forEach(function (config) {
            if (config.code == code) {
                isNew = false;
            }
        });

        if(isNew) {
            let configRepository = new ConfigRepository();
            configRepository.add(code, title, description, 'undefined', '', 0, '');
        }

    },

    async exportAction({commit}, encryptionKey) {
      let exportRepository = new ExportRepository();
      if(exportRepository.export(encryptionKey)) {
          actions.setSuccessMessage({commit}, 'Daten wurden gespeichert.');
      } else {
          actions.setErrorMessage({commit}, 'Beim Speichern ist ein Fehler aufgetreten.');
      }
    },

    async deleteCacheAction({commit}) {
        self.caches.keys().then(keys => { keys.forEach(key => self.caches.delete(key)) })
        actions.setSuccessMessage({commit}, 'Der Cache wurde gelöscht. Bitte schließen Sie die App und starten Sie sie neu.');
    },

    async importAction({commit}, params) {
        let exportRepository = new ExportRepository();

        if(exportRepository.import(params.decryptionKey, params.fileParam)){
            actions.setSuccessMessage({commit}, 'Daten wurden importiert.');
            actions.getTags({commit});
        } else {
            actions.setErrorMessage({commit}, 'Beim Import ist ein Fehler aufgetreten.');
        }
    },

    async search({commit}) {
        let contentRepository = new ContentRepository();
        let resultsPromise = contentRepository.search(state.selectedTags, state.selectedTypes, state.searchWords);
        await resultsPromise.then(function(results){
            commit('setResults', results);
        });
    },

    async addContent({commit}, params){
        let contentRepository = new ContentRepository();
        if(params.image1 !== -1 && typeof(params.image1) !== 'undefined') {
            blobToBlob2(params.image1, params, 1, saveBlob2);
        }
        if(params.image2 !== -1 && typeof(params.image2) !== 'undefined') {
            blobToBlob2(params.image2, params, 2, saveBlob2);
        }
        if(params.image3 !== -1 && typeof(params.image3) !== 'undefined') {
            blobToBlob2(params.image3, params, 3, saveBlob2);
        }
        if(params.image4 !== -1 && typeof(params.image4) !== 'undefined') {
            blobToBlob2(params.image4, params, 4, saveBlob2);
        }
        if(params.image5 !== -1 && typeof(params.image5) !== 'undefined') {
            blobToBlob2(params.image5, params, 5, saveBlob2);
        }

        function blobToBlob2(blob, content, numberOfImage, callback){
            var reader = new FileReader();
            reader.readAsArrayBuffer(blob);
            reader.onload = function(e) {
                callback({
                    buffer: e.target.result,
                    type: blob.type,
                }, numberOfImage, content);
            };
        }

        function saveBlob2(blob2, imageNumber, content) {
            switch (imageNumber) {
                case 1:
                    content.image1 = blob2;
                    break;
                case 2:
                    content.image2 = blob2;
                    break;
                case 3:
                    content.image3 = blob2;
                    break;
                case 4:
                    content.image4 = blob2;
                    break;
                case 5:
                    content.image5 = blob2;
                    break;
                default:
                    content.image1 = blob2;
            }
        }

        setTimeout(function(){
            let contentPromise = contentRepository.add(params);
            contentPromise.then(function (success) {
                if(success) {
                    actions.setSuccessMessage({commit}, 'Der Inhalt "' + params.title + '" wurde erstellt');


                } else {
                    actions.setErrorMessage({commit}, 'Es ist ein Fehler aufgetreten');
                }
            });
            }, 1000);

    },

    async updateContent({commit}, params){

        let contentRepository = new ContentRepository();
        let contentPromise = contentRepository.update(params);
        await contentPromise.then(function (success) {
            if(success) {
                actions.setSuccessMessage({commit}, 'Der Inhalt "' + params.title + '" wurde aktualisiert');
            } else {
                actions.setErrorMessage({commit}, 'Es ist ein Fehler aufgetreten');
            }
        });

        if(params.image1 !== -1 && typeof(params.image1) !== 'undefined') {
            blobToBlob2(params.image1, params, 1, saveBlob2);
        }
        if(params.image2 !== -1 && typeof(params.image2) !== 'undefined') {
            blobToBlob2(params.image2, params, 2, saveBlob2);
        }
        if(params.image3 !== -1 && typeof(params.image3) !== 'undefined') {
            blobToBlob2(params.image3, params, 3, saveBlob2);
        }
        if(params.image4 !== -1 && typeof(params.image4) !== 'undefined') {
            blobToBlob2(params.image4, params, 4, saveBlob2);
        }
        if(params.image5 !== -1 && typeof(params.image5) !== 'undefined') {
            blobToBlob2(params.image5, params, 5, saveBlob2);
        }

        function blobToBlob2(blob, content, numberOfImage, callback){
            var reader = new FileReader();
            reader.readAsArrayBuffer(blob);
            reader.onload = function(e) {
                callback({
                    buffer: e.target.result,
                    type: blob.type,
                }, numberOfImage, content);
            };
        }

        function saveBlob2(blob2, imageNumber, content){
            let contentRepository = new ContentRepository();

            switch (imageNumber) {
                case 1:
                    content.image1 = blob2;
                    break;
                case 2:
                    content.image2 = blob2;
                    break;
                case 3:
                    content.image3 = blob2;
                    break;
                case 4:
                    content.image4 = blob2;
                    break;
                case 5:
                    content.image5 = blob2;
                    break;
                default:
                    content.image1 = blob2;
            }

            contentRepository.update(content);
        }

    },

    async updateConfig({commit}, params){
        let configRepository = new ConfigRepository();
        let configPromise = configRepository.update(params);
        await configPromise.then(function (success) {
            if(success) {
                actions.setSuccessMessage({commit}, 'Der Configeintrag "' + params.code + '" wurde aktualisiert');
            } else {
                actions.setErrorMessage({commit}, 'Es ist ein Fehler aufgetreten');
            }
        });
    },

    async removeAllMessages({commit}) {
        commit('setMessages', []);
    },

    async setMessages({commit}, messages) {
        commit('setMessages', messages);
    },

    async setSuccessMessage({commit}, message) {
        commit('setMessages',  [{
            id: Date.now(),
            title: message,
            type: 'success'
        }]);
    },

    async setErrorMessage({commit}, message) {
        commit('setMessages',  [{
            id: Date.now(),
            title: message,
            type: 'danger'
        }]);
    },

    async setSearchWords({commit}, searchWords) {
        commit('setSearchWords', searchWords);
    },

    async setSelectedTags({commit}, selectedTags) {
        commit('setSelectedTags', selectedTags);
    },

    async setSelectedTypes({commit}, selectedTypes) {
        commit('setSelectedTypes', selectedTypes);
    },

    async getTags({commit}) {
        let tagRepository = new TagRepository();
        let tagsPromise = tagRepository.findAll();
        await tagsPromise.then(function (tags) {
            let tagsWithChilds = tagRepository.addChildsToTags(tags);
                commit('setTags', tagsWithChilds);
        });
     },

    async getBoxes({commit}) {

        let boxRepository = new BoxRepository();
        let boxPromise = boxRepository.findAll();

        await boxPromise.then(function (boxes) {
            let boxesWithLinks = [];

            boxes.forEach(function(box){
                let linkRepository = new LinkRepository();
                let boxWithLinksPromise = linkRepository.findByBox(box.id);
                boxWithLinksPromise.then(function(links){
                    box.links = links;
                    boxesWithLinks.push(box);
                });
            });
            commit('setBoxes', boxesWithLinks);
        });
    },

    async addTag({commit}, title) {
        let tagRepository = new TagRepository();
        title = title.trim();
        var parts = title.split('.');
        if(parts.length > 3) {
            actions.setErrorMessage({commit}, 'Tag "' + title + '" darf nur zweimal verschachtelt sein.');
            return false;
        }
        var parent = 0;
        for (let i = 0; i < parts.length; i++) {
            let findPromise = tagRepository.findByTitleAndParent(parts[i], parent);
            await findPromise.then(function (persistedTags) {
                let persistedTag = persistedTags[0];
                if (persistedTag && persistedTag.id > 0) {
                    parent = persistedTag.id;
                }
                if (!persistedTag) {
                    let newPromise = tagRepository.add(parts[i], parent);
                    newPromise.then(function (newTag) {
                        parent = newTag.id;
                        actions.getTags({commit});
                    });
                } else {
                    if(i === parts.length-1) {
                        actions.setErrorMessage({commit}, 'Der Tag "' + title + '" existiert bereits.');
                        return false;
                    }
                }
            });
        }
        actions.setSuccessMessage({commit}, 'Tag "' + title + '" wurde hinzugefügt');
    },

    async getBox({commit}, boxId) {
        let boxRepository = new BoxRepository();
        let boxPromise = boxRepository.findById(boxId);
        await boxPromise.then(function(box){
            commit('setEditBox', box[0]);
        });
    },

    async getConfig({commit}, configId) {
        let configRepository = new ConfigRepository();
        let configPromise = configRepository.findById(configId);
        await configPromise.then(function(config){
            commit('setEditConfig', config[0]);
        });
    },

    async getContent({commit}, contentId) {
        let contentRepository = new ContentRepository();
        let contentPromise = contentRepository.findById(contentId);
        await contentPromise.then(function(content){
            commit('setEditContent', content[0]);
        });
    },

    async getLink({commit}, linkId) {
        let linkRepository = new LinkRepository();
        let linkPromise = linkRepository.findById(linkId);
        await linkPromise.then(function(link){
            commit('setEditLink', link[0]);
        });
    },

    async getLinks({commit}, boxId) {
        let linkRepository = new LinkRepository();
        let linkPromise = linkRepository.findByBox(boxId);
        await linkPromise.then(function(links){
            commit('setLinks', links);
        });
    },

    async addLink({commit}, params) {
        let linkRepository = new LinkRepository();
        let linkPromise = linkRepository.add(params.title,params.color, params.href, params.box)
        await linkPromise.then(function (newLink) {
            if(newLink.id) {
                actions.setSuccessMessage({commit}, 'Der Link Box "' + newLink.title + '" wurde hinzugefügt');
            } else {
                actions.setErrorMessage({commit}, 'Es ist ein Fehler aufgetreten');
            }
        });
    },

    async addBox({commit}, params) {
        let boxRepository = new BoxRepository();
        // boxRepository.changeSchema();
        let boxPromise = boxRepository.add(params.type, params.title, params.parent, params.color, params.selected, params.dashboard, params.hidden)
        await boxPromise.then(function (newBox) {
            if(newBox.id) {
                actions.setSuccessMessage({commit}, 'Die Box "' + newBox.title + '" wurde hinzugefügt');
            } else {
                actions.setErrorMessage({commit}, 'Es ist ein Fehler aufgetreten');
            }
        });
    },

    async updateBox({commit}, box) {
        let boxRepository = new BoxRepository();
        let tabs = state.boxes.filter(function(singleBox){
            return singleBox.parent === box.parent && box.type === 'tab';
        });
        let boxPromise = boxRepository.update(box, tabs);
        await boxPromise.then(function (success) {
            if(success) {
                actions.setSuccessMessage({commit}, 'Die Box wurde aktualisiert');
            } else {
                actions.setErrorMessage({commit}, 'Es ist ein Fehler aufgetreten');
            }
        });
    },

    async updateLink({commit}, link) {
        let linkRepository = new LinkRepository();
        let linkPromise = linkRepository.update(link);
        await linkPromise.then(function (success) {
            if(success) {
                actions.setSuccessMessage({commit}, 'Der Link wurde aktualisiert');
            } else {
                actions.setErrorMessage({commit}, 'Es ist ein Fehler aufgetreten');
            }
        });
    },

    async deleteTag({commit}, tag) {
        if (tag.childs.length > 0) {
            actions.setErrorMessage({commit}, 'Tags mit Kindelementen können nicht gelöscht werden.');
            return false;
        } else {
            let tagRepository = new TagRepository();
            tagRepository.remove(tag.id);
            actions.setSuccessMessage({commit}, 'Tag "' + tag.title + '" wurde gelöscht.');
            commit('removeTag', tag.id);
            await actions.getTags({commit});
        }
    },

    async deleteContent({commit}, content) {
        let contentRepository = new ContentRepository();
        contentRepository.remove(content.id);
        await actions.setSuccessMessage({commit}, 'Inhalt "' + content.title + '" wurde gelöscht.');
        commit('removeContent', content.id);
    },

    async deleteLink({commit}, link) {
        let linkRepository = new LinkRepository();
        linkRepository.remove(link.id);
        await actions.setSuccessMessage({commit}, 'Link "' + link.title + '" wurde gelöscht.');
        await actions.getLinks({commit}, link.box);
    },

    async deleteBox({commit}, box) {
        let boxRepository = new BoxRepository();
        boxRepository.remove(box.id);
        await actions.setSuccessMessage({commit}, 'Box "' + box.title + '" wurde gelöscht.');
        await actions.getBoxes({commit});
    },
};

const mutations = {
    pushDashboardItem: function(state, dashboardItem) {
      state.dashboard.push(dashboardItem);
    },
    setTags: (state, tags) => (state.tags = tags),
    setLinks: (state, links) => (state.links = links),
    setBoxes: (state, boxes) => (state.boxes = boxes),
    setResults: (state, results) => (state.results = results),
    setContents: (state, contents) => (state.contents = contents),
    setConfigs: (state, configs) => (state.configs = configs),
    setMessages: (state, messages) => (state.messages = messages),
    newTag: (state, tag) => state.tags.unshift(tag),
    removeTag: (state, id) =>
        (state.tags = state.tags.filter(tag => tag.id !== id)),
    removeContent: (state, id) =>
        (state.results = state.results.filter(result => result.id !== id)),
    setSelectedTags: (state, selectedTags) => (state.selectedTags = selectedTags),
    setSelectedTypes: (state, selectedTypes) => (state.selectedTypes = selectedTypes),
    setSearchWords: (state, searchWords) => (state.searchWords = searchWords),
    setEditBox: (state, box) => (state.editBox = box),
    setEditConfig: (state, config) => (state.editConfig = config),
    setEditContent: (state, content) => (state.editContent = content),
    setEditLink: (state, link) => (state.editLink = link)
};

export default {
    state,
    getters,
    actions,
    mutations
};
